import withHandlers from 'recompose/withHandlers';
import moment from 'moment-timezone';

export default withHandlers({
  fetchSummary: props => () => {
    if (!props.currentDate) return null;
    const from = moment.tz(props.currentDate, props.timezone).startOf('day').toJSON();
    const to = moment.tz(props.currentDate, props.timezone).endOf('day').toJSON();
    return props.fetchSummary(props.ownerId, props.ownerType, from, to);
  },
  fetchSummaryForBarbers: props => (barberIds) => {
    if (!props.currentDate) {
      return null;
    }
    const from = moment.tz(props.currentDate, props.timezone).startOf('day').toJSON();
    const to = moment.tz(props.currentDate, props.timezone).endOf('day').toJSON();

    return props.fetchSummary(props.ownerId, props.ownerType, from, to, barberIds);
  },
});
